const getClassrooms = (classrooms = []) => {
  const options = classrooms.map((item) => ({
    value: item.classroomId || '',
    label: item.name || ''
  }));

  return options;
};

const getGroups = (classId = '', classrooms = []) => {
  let classroom = classrooms.find(
    (classItem) => classItem.classroomId === Number(classId)
  );
  if (!classroom) classroom = classrooms[0];
  if (classroom && classroom.groups && classroom.groups instanceof Array) {
    const options = classroom.groups.map((item) => ({
      value: item.groupId,
      label: item.name
    }));

    options.sort((a, b) => a.label.localeCompare(b.label));

    return options;
  }
  return [];
};

const getStudents = (classId, groupId, classrooms) => {
  const classroom = classrooms.find((c) => c.classroomId === classId);
  if (groupId === '-1') {
    const students = [];
    for (const group of classroom.groups) {
      for (const student of group.students) {
        const isStudentExists = students.find(
          (s) => s.encryptedUserProfileId === student.encryptedUserProfileId
        );
        if (!isStudentExists) {
          students.push(student);
        }
      }
    }
    return students;
  }
  const group = classroom.groups.find((g) => g.groupId === groupId);
  return group.students.map((student) => {
    return {
      ...student,
      groupName: group.name,
      className: classroom.name,
      classroomId: classroom.classroomId
    };
  });
};

const setDefaultValues = (isClass, classrooms) => {
  if (isClass) {
    return {
      value: classrooms[0].classroomId,
      label: classrooms[0].name
    };
  }

  return {
    value: classrooms[0].groups[0].groupId,
    label: classrooms[0].groups[0].name
  };
};

export { getClassrooms, getGroups, getStudents, setDefaultValues };



// WEBPACK FOOTER //
// ./components/filters/filters-util.js